<template>
  <div style="min-height: 100vh;" class="c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="container top-spacing colum">
      <div class="golf-good-price mb-10">
        <div class="top-post-container mb-10">
          <p class="fw-600 m-0 text-uppercase c-body">
            {{ $t("wap.text148") }}
          </p>
        </div>
        <!-- <p class="c-black-text c-bold-text title-h3 cursor-pointer m-0">
          {{ $t("wap.text148") }}
        </p> -->
      </div>
      <el-row :gutter="20">
        <el-col
          v-for="(item, index) in list_news"
          :key="index"
          :xs="24"
          :sm="24"
          :md="12"
          :lg="12"
          :xl="12"
        >
          <card-news
            style="margin-bottom: 15px;"
            class="w-100"
            :object-data="item"
            :excerpt="item.excerpt"
            :title="item.title"
            :banner="item.banner"
            :author-name="item.author_name"
            :id="item.post_id"
          />
        </el-col>
      </el-row>
      <div v-if="list_news.length > 0" class="mt-20 mb-20 text-center">
        <button-customer
          style="width:120px"
          :styles="{
            fontSize: '12px',
            fontWeight: 500,
            height: '30px',
            borderRadius: '5px',
            padding: '5px 0px'
          }"
          :loading-submit="isLoading"
          :object-data="{ title: $t('viewMore') }"
          @on-action="loadMore"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getBackGround } from "@/utils/wapAuth";
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";
import CardNews from "@/components/wapV2/cards/CardNewsMain.vue";
import ReviewFacility from "@/views/api/wapV2/review-facility";
import { mapGetters, mapActions } from "vuex";
import ButtonCustomer from "@/components/wapV2/button/index.vue";

export default {
  components: {
    MainNavBarWapV2,
    CardNews,
    ButtonCustomer
  },
  name: "page-news",
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.onGetList();
  },
  data() {
    return {
      isLoading: false,
      bg: getBackGround(),
      infoHeader: {
        title: this.$t("wap.text148"),
        isShowHomeIcon: true
      },
      page: 1
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["list_news"])
  },
  methods: {
    ...mapActions(["set_data_news"]),
    loadMore() {
      this.page += 1;
      this.onGetList(true);
    },

    onGetList(is_reload = false) {
      if (this.list_news.length > 0 && !is_reload) return;
      this.isLoading = true;
      ReviewFacility.get_data_post({ page: this.page })
        .then(res => {
          const { error_code, data = [] } = res;
          if (error_code === 0 && data.length > 0) {
            const mapData = data.map(i => {
              const obj = {
                ...i,
                id: i.course_id,
                title: i.post.title,
                excerpt: i.post.excerpt,
                banner: i.post.banner,
                author_name: i.post.author
              };
              return obj;
            });
            this.set_data_news([...this.list_news, ...mapData]);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.top-spacing {
  padding-top: 100px;
}
.full-width {
  width: 100%;
}
.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}

.desktop {
  display: block;
}

.mobile {
  display: none;
}
.golf-good-price {
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title-h3 {
    font-size: 16px;
  }
  .top-post-container {
    min-width: 200px;
    background: #f0f0f0;
    border-left: 4px solid #111827;
    padding: 8px 15px;
    color: #111827;
    font-size: 16px;
    font-weight: 700;
  }
}
@media screen and (min-width: 0px) and (max-width: 480px) {
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .top-spacing {
    padding-top: 65px;
  }
  .top-spacing1 {
    padding-top: 170px;
  }
  .title-h3 {
    font-size: 14px;
  }
}
@media screen and (min-width: 0px) and (max-width: 980px) {
  .title-section {
    display: none;
  }
}
</style>
